import RcTable from 'rc-table';
import { ColumnsType, DefaultRecordType } from 'rc-table/lib/interface';
import { TODO_ANY } from 'typings/common';

function Table({ columns, dataSource }: { columns: ColumnsType<DefaultRecordType> | undefined; dataSource: TODO_ANY }) {
  return <RcTable columns={columns} data={dataSource} rowKey="id" />;
}

export default Table;
